(function($, Drupal) {
    var getBaseConfig = function($element) {
        var config = {
            allowInput: true,
            enable: [],
            disable: [],
        };

        if ($element.data('disabledDateRange')) {
            var disabledRange = $element.data('disabledDateRange').split(' ');

            config.disable.push({
                from: disabledRange[0],
                to: disabledRange[1],
            });
        }

        if ($element.data('enabledDateRange')) {
            var enabledRange = $element.data('enabledDateRange').split(' ');

            config.enable.push({
                from: enabledRange[0],
                to: enabledRange[1],
            });
        }

        if ($element.data('disabledDates')) {
            $element
                .data('disabledDates')
                .split(' ')
                .forEach(function(date) {
                    config.disable.push(date);
                });
        }

        if ($element.data('enabledDates')) {
            $element
                .data('enabledDates')
                .split(' ')
                .forEach(function(date) {
                    config.enable.push(date);
                });
        }

        return config;
    };

    Drupal.behaviors.flatpickr = {
        attach: function(context) {
            $(context)
                .find('input[type="date"]')
                .not('.flatpickr-disabled')
                .once('flatpickr')
                .each(function() {
                    var $element = $(this);

                    var config = getBaseConfig($element);
                    config.dateFormat = $element[0].dataset.drupalDateFormat;
                    config.altInput = true;
                    config.altFormat = 'd/m/Y';
                    config.onClose = function(selectedDates, dateStr, fp) {
                        fp.setDate(fp._input.value, true, 'd/m/Y');
                    };

                    $element.flatpickr(config);
                });

            $(context)
                .find('input[type="time"], input[type="datetime-local"]')
                .not('.flatpickr-disabled')
                .once('flatpickr')
                .each(function() {
                    var $element = $(this);

                    var config = getBaseConfig($element);
                    config.enableTime = true;
                    config.enableSeconds = true;
                    config.noCalendar = true;
                    config.time_24hr = true;
                    config.dateFormat = 'H:i:S';
                    config.defaultHour = 23;
                    config.defaultMinute = 59;
                    config.defaultSeconds = 59;
                    config.onClose = function(selectedDates, dateStr, fp) {
                        fp.setDate(fp._input.value, true, 'H:i:S');
                    };

                    $element.flatpickr(config);
                });
        },
    };
})(jQuery, Drupal);
